import { render, staticRenderFns } from "./ItsBaseCustoms.vue?vue&type=template&id=5694d263&scoped=true&"
import script from "./ItsBaseCustoms.vue?vue&type=script&lang=js&"
export * from "./ItsBaseCustoms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5694d263",
  null
  
)

export default component.exports